export default __webpack_public_path__ + "static/media/icon-error.49af2d08.svg";